import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-698dee31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w100 modal-import" }
const _hoisted_2 = { class: "fh-c import-head" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "import-row"
}
const _hoisted_5 = {
  border: "1",
  bordercolor: "#e6e6e6",
  width: "100%",
  co: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { height: "32" }, [
  /*#__PURE__*/_createElementVNode("td", { style: {"padding":"0 11px"} }, "Excel文件标题"),
  /*#__PURE__*/_createElementVNode("td", { style: {"padding":"0 11px"} }, "对应系统中的字段")
], -1))
const _hoisted_7 = { height: "32" }
const _hoisted_8 = { style: {"padding":"0 11px"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("覆盖更新")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "import-tips",
  style: {"margin-top":"10px"}
}, "如果email或手机号匹配到现有客服，则更新其资料，如匹配到现有客户，则将其转为客服并更新资料", -1))
const _hoisted_11 = {
  key: 1,
  class: "import-result"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("，修改并删除失败原因列后重新导入")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("完成")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_modal_import_detail = _resolveComponent("modal-import-detail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModal) = $event)),
      title: "客服导入",
      style: {"width":"680px"}
    }, {
      footer: _withCtx(() => [
        _withDirectives(_createVNode(_component_a_button, {
          key: "back",
          onClick: _ctx.handleCancel
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, !_ctx.hasComplete]
        ]),
        _withDirectives(_createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          disabled: !_ctx.excel,
          loading: _ctx.isLoading,
          onClick: _ctx.handleOk
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"]), [
          [_vShow, !_ctx.hasComplete]
        ]),
        _withDirectives(_createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          onClick: _ctx.handleFinish
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_vShow, _ctx.hasComplete]
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (!_ctx.hasComplete)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadTemplate && _ctx.handleDownloadTemplate(...args)))
                  }, "Excel模板"),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleUpload && _ctx.handleUpload(...args)))
                  }, "选择文件"),
                  _createElementVNode("a", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDetail && _ctx.handleDetail(...args)))
                  }, "详细说明"),
                  (_ctx.excel)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.excel.name), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.titleOptions.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("table", _hoisted_5, [
                        _createElementVNode("tbody", null, [
                          _hoisted_6,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleOptions, (to) => {
                            return (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                              _createElementVNode("td", _hoisted_8, _toDisplayString(to.title), 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_a_select, {
                                  value: to.selectProperty,
                                  "onUpdate:value": ($event: any) => ((to.selectProperty) = $event),
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (op) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        value: op.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(op.option), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 256))
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onUpdate:value"])
                              ])
                            ]))
                          }), 256))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_checkbox, {
                  checked: _ctx.update,
                  "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.update) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["checked"]),
                _hoisted_10
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(" 导入成功" + _toDisplayString(_ctx.importResult.successCount) + "个", 1),
                (_ctx.importResult.failureCount>0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode("，失败 " + _toDisplayString(_ctx.importResult.failureCount) + "个 ", 1),
                      _createElementVNode("a", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadFailure && _ctx.handleDownloadFailure(...args)))
                      }, "点击下载导入失败的列表"),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_modal_import_detail, {
      visible: _ctx.detailVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detailVisible) = $event))
    }, null, 8, ["visible"])
  ], 64))
}